import vSelect from "vue-select";
import ListSelectedVisitPoints from "@/components/optimization/visit-point/ListSelectedVisitPoints.vue";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import moduleMap from "@/store/map/moduleMap.js";
import VehicleList from "@/components/vehicle/list/VehicleList.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AddResource from "@/components/optimization/resource/create/AddResource.vue";
import ResourceUpdate from "@/components/optimization/resource/edit/ResourceUpdate.vue";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import {Validator} from "vee-validate";
import {en, es} from "vuejs-datepicker/src/locale";
import moment from "moment";
import DateUtils from "@/helpers/DateUtils.js";
import ListSelectVehicle from "@/components/optimization/resource/ListSelectVehicle.vue";
import OptimizationCreate from "@/components/optimization/OptimizationCreate.vue";
import OptimizationErrors from "@/components/optimization/OptimizationErrors.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import JobPlanningForm from "@/components/optimization/jobs/JobPlanningForm.vue";

export const ReOptimizationEditMixin = {
	name: "ReOptimizationEdit",
	components: {
		vSelect,
		VuePerfectScrollbar,
		ListSelectedVisitPoints,
		AddResource,
		ResourceUpdate,
		Datepicker,
		flatPickr,
		VehicleList,
		ListSelectVehicle,
		OptimizationCreate,
		OptimizationErrors,
		FloatingButtons,
		JobPlanningForm,
	},
	data() {
		return {
			activeItem: "0",
			activeTabVisitPoint: false,
			activeTabResource: false,
			activePrompt: false,
			nameOptimization: "",
			resourceMounted: false,
			searchQuery: "",
			resourceObject: {},
			langHe: es,
			langEn: en,
			errorsActive: false,
			optimizationErrors: [],
			dataOptimization: {},
			activeDiscardedItemsPrompt: false,
			discardedItemsList: [],
			discardedItemsPerPage: 20,
			currentDiscardedItemsPage: 1,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			vehicleListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: [
					"id",
					"identification",
					"profile",
					"max_travel_distance",
					"max_travel_duration",
					"init_depot_name",
					"end_depot_name",
				],
				actionDropdown: false,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				CellRendererDemand: false,
				showItemsPerPage: false,
				showPopup: true,
				showButtonAdd: false,
				showButtonSelected: true,
			},
			objectives: [
				{
					label: this.$t("MinimizeUnassigned"),
					value: "minimize_unassigned",
				},
				{
					label: this.$t("MinimizeCost"),
					value: "minimize_cost",
				},
				{
					label: this.$t("MinimizeDistance"),
					value: "minimize_distance",
				},
				{
					label: this.$t("MinimizeDuration"),
					value: "minimize_duration",
				},
				{
					label: this.$t("MinimizeTourCount"),
					value: "minimize_tour_count",
				},
				{
					label: this.$t("MaximizeTourCount"),
					value: "maximize_tour_count",
				},
			],
		};
	},
	watch: {
		activeItem(val) {
			if (val === "1") {
				this.activeTabResource = true;
			} else if (val === "0") {
				this.activeTabVisitPoint = true;
				setTimeout(() => {
					this.$refs.ListSelectedVisitPoint.initMap();
				}, 600);
			}
		},
		resourceMounted(val) {
			if (val) {
				this.vehicleListConfig.tableOptions = false;
			}
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		Validator.extend("validatorEndHourOptimization", this.validatorEndHourOptimization);
		Validator.extend("validatorInitHourOptimization", this.validatorInitHourOptimization);
		Validator.extend("validatorInitDateOptimization", this.validatorInitDateOptimization);
		Validator.extend("validatorEndDateOptimization", this.validatorEndDateOptimization);
		this.getVehicles(1);
	},
	mounted() {
		setTimeout(() => {
			this.initMapOptimization();
		}, 600);
	},
	computed: {
		getNameOptimization() {
			return this.$store.state.moduleOptimization.standardInputList["name"];
		},
		selectedResources() {
			return this.$store.state.moduleOptimization.standardInputList["vehicles"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["vehicles"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["vehicles"];
		},
		getCheckedVehicles() {
			return this.$store.state.vehicle.checkedVehicles === undefined ||
				this.$store.state.vehicle.checkedVehicles === "" ||
				this.$store.state.vehicle.checkedVehicles === null
				? []
				: this.$store.state.vehicle.checkedVehicles;
		},
		validFormPrompt() {
			return this.dataOptimization.nameOptimization != "";
		},
		selectedRoutingType() {
			return this.$store.state.routingType;
		},
		selectedTypeVehicle() {
			return this.$store.state.moduleRoutingType.typeVehicle;
		},
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		// Pagination computed properties for discarded items
		paginatedDiscardedItems() {
			const startIndex = (this.currentDiscardedItemsPage - 1) * this.discardedItemsPerPage;
			const endIndex = startIndex + this.discardedItemsPerPage;
			return this.discardedItemsList.slice(startIndex, endIndex);
		},
		totalDiscardedItemsPages() {
			return Math.ceil(this.discardedItemsList.length / this.discardedItemsPerPage);
		},
		showDiscardedItemsPagination() {
			return this.discardedItemsList.length > this.discardedItemsPerPage;
		},
	},
	methods: {
		acceptPrompt() {
			if (this.selectedRoutingType === "OPENROUTE" && !this.dataOptimization.hasOwnProperty("mesh")) {
				this.activePrompt = true;
				return;
			}
			this.generateOptimization();
		},
		closePrompt() {},
		showPrompt() {
			const countPickup = this.standardInput.hasOwnProperty("pickups") ? this.standardInput["pickups"].length : 0;
			const countDelivery = this.standardInput.hasOwnProperty("deliveries")
				? this.standardInput["deliveries"].length
				: 0;
			const countVehicles = this.standardInput.hasOwnProperty("vehicles")
				? this.standardInput["vehicles"].length
				: 0;
			if (countPickup + countDelivery <= 1) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.ValidData.Title"),
					text: this.$t("Optimization.ValidateOptimizationVisitpointText"),
					time: 9000,
				});
				return;
			}
			if (countVehicles <= 0) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPoints.ValidData.Title"),
					text: this.$t("Optimization.ValidateOptimizationResourceText"),
					time: 9000,
				});
				return;
			}
			this.dataOptimization = {
				nameOptimization: this.getNameOptimization,
				selectedRouter: this.selectedRoutingType,
				selectedVehicleProfile: this.selectedTypeVehicle,
				profileOption: "general",
				period: {
					init_date: moment(this.standardInput["global_config"].init_date).format(),
					end_date: moment(this.standardInput["global_config"].end_date).format(),
					init_hour: this.standardInput["global_config"].init_hour,
					end_hour: this.standardInput["global_config"].end_hour,
				},
			};
			if (this.selectedRoutingType === "TOUR_PLANNING" || this.selectedRoutingType === "GMPRO") {
				if (this.standardInput.hasOwnProperty("global_config")) {
					if (this.standardInput.global_config.hasOwnProperty("objectives"))
						this.dataOptimization.objectiveListSelected = this.objectives.filter((data) =>
							this.standardInput.global_config["objectives"].includes(data.value)
						);
				}
			}
			if (this.selectedRoutingType === "TOUR_PLANNING") {
				if (this.standardInput.hasOwnProperty("global_config")) {
					if (this.standardInput.global_config.hasOwnProperty("live_traffic"))
						this.dataOptimization.liveTraffic = this.standardInput.global_config["live_traffic"];
				}
			}
			this.activePrompt = true;
		},
		generateOptimization() {
			this.$validator.validateAll("create-optimization").then((isValid) => {
				if (!isValid) {
					this.showValidationError();
					return;
				}
				this.prepareResources();
				const payload = this.buildPayload();
				this.showLoadingWizard();
				this.$store
					.dispatch("moduleOptimization/optimization", payload)
					.then((res) => this.handleOptimizationResponse(res))
					.catch((err) => {
						this.handleOptimizationError(err);
					});
			});
		},
		showValidationError() {
			this.activePrompt = true;
			this.$vs.notify({
				color: "warning",
				title: this.$t("ErrorFields.Title"),
				text: this.$t("ErrorFields.Text"),
			});
		},
		prepareResources() {
			switch (this.selectedRoutingType) {
				case "OPENROUTE":
					this.removeProperties(this.selectedResources, ["max_travel_duration", "max_travel_distance"]);
					break;
				case "GMPRO":
					this.removeProperties(this.standardInput["pickups"], ["priority"]);
					this.removeProperties(this.standardInput["deliveries"], ["priority"]);
					break;
				case "TOUR_PLANNING":
					this.removeProperties(this.selectedResources, ["max_travel_duration", "time_window"]);
					this.adjustTimeService(this.standardInput["pickups"]);
					this.adjustTimeService(this.standardInput["deliveries"]);
					break;
			}
		},
		removeProperties(items, properties) {
			if (!items || !Array.isArray(items) || items.length <= 0) {
				return;
			}
			if (!properties || !Array.isArray(properties) || properties.length <= 0) {
				return;
			}
			items.forEach((item) => {
				properties.forEach((prop) => delete item[prop]);
			});
		},
		adjustTimeService(items) {
			if (items) {
				items.forEach((item) => {
					if (item.time_service === "00:00:00") {
						item.time_service = "00:00:01";
					}
				});
			}
		},
		buildPayload() {
			const payload = {
				name: this.dataOptimization.nameOptimization,
				vehicles: this.standardInput["vehicles"],
				routing_api: this.selectedRoutingType,
				deliveries: this.standardInput["deliveries"],
				pickups: this.standardInput["pickups"],
				global_config: {
					init_date: DateUtils.toDefaultDateTime(this.dataOptimization.period.init_date, "YYYY-MM-DD"),
					end_date: DateUtils.toDefaultDateTime(this.dataOptimization.period.end_date, "YYYY-MM-DD"),
					init_hour: this.dataOptimization.period.init_hour,
					end_hour: this.dataOptimization.period.end_hour,
				},
			};

			if (this.standardInput.hasOwnProperty("jobs") && this.standardInput["jobs"].length > 0) {
				payload.jobs = this.standardInput["jobs"];
			}

			if (this.dataOptimization.group) {
				payload.optimization_group_id = this.dataOptimization.group.value;
			}

			if (this.selectedRoutingType === "OPENROUTE") {
				payload.global_config.mesh = this.dataOptimization.mesh.value;
			}

			if (this.selectedRoutingType === "TOUR_PLANNING") {
				payload.global_config.live_traffic = this.dataOptimization.liveTraffic;
				if (this.dataOptimization.objectiveListSelected && this.dataOptimization.objectiveListSelected.length) {
					payload.global_config.objectives = this.dataOptimization.objectiveListSelected.map(
						(data) => data.value
					);
				}
			}

			if (this.selectedRoutingType === "TOUR_PLANNING" || this.selectedRoutingType === "GMPRO") {
				if (this.dataOptimization.objectiveListSelected && this.dataOptimization.objectiveListSelected.length) {
					payload.global_config.objectives = this.dataOptimization.objectiveListSelected.map(
						(data) => data.value
					);
				}
			}

			if (this.selectedRoutingType === "TOUR_PLANNING") {
				payload.global_config.live_traffic = this.dataOptimization.liveTraffic;
				if (this.dataOptimization.advanced_objectives && this.dataOptimization.advanced_objectives.length) {
					payload.global_config.advanced_objectives = this.dataOptimization.advanced_objectives;
				}
			}

			if (
				this.dataOptimization.hasOwnProperty("profileOption") &&
				this.dataOptimization.profileOption === "general"
			) {
				payload.global_config.global_profile = this.dataOptimization.selectedVehicleProfile;
			}

			return payload;
		},
		showLoadingWizard() {
			this.$vs.loading({
				container: "#wizard-with-loading-optimization",
				text: this.$t("ValidatingTheInformationProvided"),
			});
		},
		handleOptimizationResponse(res) {
			if (res.data.status === 400 || res.data.optimizer.status === 400) {
				this.processOptimizationErrors(res);
				return;
			}
			this.$store.commit("moduleOptimization/DELETE_ALL_ERROR_OPTIMIZATION");
			this.$vs.loading.close("#wizard-with-loading-optimization > .con-vs-loading");
			this.$router.push({name: "OptimizationList"});
		},
		processOptimizationErrors(res) {
			this.optimizationErrors = [];
			const addErrorDetails = (errors) => {
				errors.forEach((err) => {
					const absolutePath = err.absolute_path.join("/");
					this.optimizationErrors.push({message: err.validator || err.message, absolutePath});
				});
			};
			if (res.data.optimizer.data) addErrorDetails(res.data.optimizer.data);
			if (res.data.optimizer.error) addErrorDetails(res.data.optimizer.error);
			if (res.data.errors.length) {
				this.addIndexToPoints("pickups");
				this.addIndexToPoints("deliveries");
				this.$store.commit("moduleOptimization/SET_ERROR_OPTIMIZATION", res.data.errors);
			}
			this.selectedResources.forEach((resource, index) => (resource.indexResource = index));
			this.errorsActive = true;
			this.$vs.loading.close("#wizard-with-loading-optimization > .con-vs-loading");
		},
		addIndexToPoints(type) {
			if (this.standardInput[type].length) {
				this.standardInput[type].forEach((point, index) => (point.indexVisitPoint = index));
			}
		},
		handleOptimizationError(err) {
			console.error(err);
			this.$vs.loading.close("#wizard-with-loading-optimization > .con-vs-loading");
		},
		validateInputName(event) {
			let regex = /^[a-zA-Z0-9_-]+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		initMapOptimization(val) {
			this.activeTabVisitPoint = true;
		},
		setAssignedResource() {
			let vehicleList = {};
			const payload = {
				pickups: {},
				deliveries: {},
				global_config: {
					init_date: DateUtils.toDefaultDateTime(this.standardInput["global_config"].init_date, "YYYY-MM-DD"),
					end_date: DateUtils.toDefaultDateTime(this.standardInput["global_config"].end_date, "YYYY-MM-DD"),
					init_hour: this.standardInput["global_config"].init_hour,
					end_hour: this.standardInput["global_config"].end_hour,
				},
			};
			if (this.getCheckedVehicles.length > 0) {
				vehicleList["serviroutes_vehicle_ids"] = this.getCheckedVehicles.map(({id}) => id);
			}
			if (Object.entries(vehicleList).length > 0) payload.vehicles = vehicleList;
			this.$store
				.dispatch("moduleOptimization/generateStandardInputFilter", payload)
				.then((res) => {
					if (
						res.data &&
						res.data.warnings &&
						Array.isArray(res.data.warnings) &&
						res.data.warnings.length > 0
					) {
						const discardedItems = res.data.warnings.filter(
							(item) => typeof item === "string" && item.includes("discarded due to frequencies")
						);

						if (discardedItems.length > 0) {
							this.showDiscardedItemsPrompt(discardedItems);
						}
					}
					this.$store.commit("moduleOptimization/SET_VEHICLE_STANDARD_INPUT", res.data["vehicles"]);
					this.resourceMounted = false;
					this.searchQuery = "";
					return res;
				})
				.catch((err) => {
					if (this.getCheckedVehicles.length <= 0) {
						this.$vs.notify({
							color: "warning",
							title: this.$t("RouterSelection.Step2Title"),
							text: this.$t("RouterSelection.TotalResourceInsideToContinue"),
							time: 7000,
						});
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("ErrorTitle"),
							text: this.$t("ErrorMessage"),
							time: 7000,
						});
					}
					console.error(err);
					return err;
				});
		},
		showPopup() {
			this.resourceMounted = false;
			this.searchQuery = "";
		},
		updateSearchQuery(val) {
			this.$refs.VehicleListPopup.updateSearchQuery(val);
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		validatorInitDateOptimization(value, args) {
			this.removeError("initDateOptimization");
			this.removeError("endDateOptimization");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.dateOptimization.end_date === "string"
					? new Date(this.dateOptimization.end_date).getTime()
					: this.dateOptimization.end_date.getTime();
			return ih <= eh;
		},
		validatorEndDateOptimization(value, args) {
			this.removeError("initDateOptimization");
			this.removeError("endDateOptimization");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.dateOptimization.init_date === "string"
					? new Date(this.dateOptimization.init_date).getTime()
					: this.dateOptimization.init_date.getTime();
			return eh >= ih;
		},
		validatorEndHourOptimization(value, args) {
			this.removeError("dataHourInitOptimization");
			this.removeError("dataHourEndOptimization");
			const dateInit =
				typeof this.dateOptimization.init_date === "string"
					? new Date(this.dateOptimization.init_date).getTime()
					: this.dateOptimization.init_date.getTime();
			const dateEnd =
				typeof this.dateOptimization.end_date === "string"
					? new Date(this.dateOptimization.end_date).getTime()
					: this.dateOptimization.end_date.getTime();
			if (this.dateOptimization.init_hour === "" || value === "" || dateInit != dateEnd) {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.dateOptimization.init_hour);
		},
		validatorInitHourOptimization(value, args) {
			this.removeError("dataHourInitOptimization");
			this.removeError("dataHourEndOptimization");
			const dateInit =
				typeof this.dateOptimization.init_date === "string"
					? new Date(this.dateOptimization.init_date).getTime()
					: this.dateOptimization.init_date.getTime();
			const dateEnd =
				typeof this.dateOptimization.end_date === "string"
					? new Date(this.dateOptimization.end_date).getTime()
					: this.dateOptimization.end_date.getTime();
			if (this.dateOptimization.end_hour === "" || value === "" || dateInit != dateEnd) {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.dateOptimization.end_hour);
		},
		async getVehicles(page) {
			const payload = {
				page,
				quantity: this.quantityElementPage,
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("vehicle/findVehiclePaginated", payload)
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		optimizationFields(data) {
			this.dataOptimization = data;
		},
		activePopup(val) {
			this.errorsActive = val;
		},
		showDiscardedItemsPrompt(discardedItems) {
			// Parse and translate the discarded items
			const translatedItems = discardedItems.map((item) => {
				// Parse the item string: "TYPE identifier, discarded due to frequencies."
				const parts = item.split(",");
				if (parts.length >= 2) {
					const typeAndIdentifier = parts[0].trim();
					// Split type and identifier
					const spaceIndex = typeAndIdentifier.indexOf(" ");
					if (spaceIndex !== -1) {
						const type = typeAndIdentifier.substring(0, spaceIndex).trim();
						const identifier = typeAndIdentifier.substring(spaceIndex + 1).trim();
						// Translate the type
						let translatedType = type;
						if (type === "PICKUP") {
							translatedType = this.$t("Frequency.DiscardedItems.Pickup");
						} else if (type === "DELIVERY") {
							translatedType = this.$t("Frequency.DiscardedItems.Delivery");
						} else if (type === "VEHICLE") {
							translatedType = this.$t("Frequency.DiscardedItems.Vehicle");
						}
						return `${translatedType} ${identifier}`;
					}
				}
				return item; // Return original if parsing fails
			});

			// Store the translated items and activate the prompt
			this.discardedItemsList = translatedItems;
			this.currentDiscardedItemsPage = 1; // Reset to first page
			this.activeDiscardedItemsPrompt = true;
		},
		// Pagination methods for discarded items
		changeDiscardedItemsPage(page) {
			if (page >= 1 && page <= this.totalDiscardedItemsPages) {
				this.currentDiscardedItemsPage = page;
			}
		},
		closeDiscardedItemsPrompt() {
			this.activeDiscardedItemsPrompt = false;
			this.currentDiscardedItemsPage = 1;
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleOptimization/DELETE_ALL_ERROR_OPTIMIZATION");
	},
};
